import gql from 'graphql-tag';

/**
 * Distinct group role names (each with the ids of every group role sharing
 * that name) scoped to a set of channels, for the assign permissions
 * wizard's team-selection step. Paginated and optionally filtered by name so
 * the wizard's teams table can search server-side.
 */
export const distinctGroupRoleNamesByChannelIdsQuery = gql`
  query DistinctGroupRoleNamesByChannelIds(
    $channelIds: [UUID!]!
    $name: String
    $pagination: PaginationInput!
  ) {
    distinctGroupRoleNames(
      channelIds: $channelIds
      name: $name
      pagination: $pagination
    ) {
      items {
        name
        groupRoleIds
      }
      pageInfo {
        start
        total
        perPage
      }
    }
  }
`;

/** Bulk-assigns a set of permissions to the given GroupRoles. */
export const bulkAssignGroupRolePermissionsMutation = gql`
  mutation BulkAssignGroupRolePermissions(
    $input: BulkAssignGroupRolePermissionsInput!
  ) {
    bulkAssignGroupRolePermissions(input: $input) {
      succeededIds
      failed {
        groupRoleId
        reason
      }
    }
  }
`;
